import { Link } from "react-router-dom";
import { MaskLines, Reveal } from "@/components/Motion";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative mx-auto max-w-[1440px] px-5 md:px-10 py-28 md:py-48">
    <div className="grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-9">
        <p className="eyebrow mb-8 flex items-center gap-4"><span className="w-10 h-px bg-gold" />Your order awaits</p>
        <MaskLines
          testId="final-cta-title"
          lines={["Let’s make", <span className="italic text-mocha">something sweet.</span>]}
          className="font-display font-light text-[3.6rem] sm:text-7xl lg:text-[8.5rem] leading-[0.9] tracking-[-0.01em]"
        />
      </div>
      <Reveal delay={0.2} className="lg:col-span-3">
        <p className="text-mocha leading-relaxed mb-8">Browse the shop or tell us about your celebration. Pickup in Clifton Heights, PA.</p>
        <Link to="/shop" data-testid="final-cta-start-order" className="btn btn-dark w-full sm:w-auto">Start Your Order</Link>
      </Reveal>
    </div>
  </section>
);
